export default {
    state: {
        activeHouse: null,
        items: [
            {
                id: 1,
                region: "Регион",
                city: "Город",
                street: "Улица",
                houseNumber: "1",
                flats: [
                    {
                        id: "id",
                        number: 1,
                        entranceNumber: 1,
                        activationPassword: "123"
                    }
                ],
                intercoms: [
                    {
                        id: "id",
                        name: "Название домофона",
                        flatsRanges: ["1-10", "12-14"],
                        ip: "127.0.0.1",
                        port: 8000,

                        ipForVideo: "127.0.0.1",
                        loginForVideo: "testLogin",
                        passwordForVideo: "testPassword",
                        portForVideo: 8000,

                        SIPAddress: "127.0.0.1",
                        SIPLogin: "testSipLogin",
                        SIPPassword: "testSipPassword",

                        loginForHTTP: "testHTTPLogin",
                        passwordForHTTP: "testHTTPPassword",

                        // data for front
                        active: false
                    }
                ]
            }
        ]
    },
    actions: {
        async loadData(ctx) {
            ctx.commit("clearItems")
            let res = await ctx.dispatch("request", {
                path: "/adm/buildings",
                method: "GET"
            })
            if (res.status == 200) {
                for (let i = 0; i < res.response.data.length; i++) {
                    let item = {
                        id: res.response.data[i].id,
                        region: res.response.data[i].region,
                        city: res.response.data[i].city,
                        street: res.response.data[i].street,
                        houseNumber: res.response.data[i].house,
                        flats: [],
                        intercoms: []
                    }
                    ctx.commit("addItem", item)
                    ctx.dispatch("loadFlats", item.id)
                    ctx.dispatch("loadIntercoms", item.id)
                }
            }
        },
        loadFlats(ctx, buildingID) {
            ctx.dispatch("request", {
                path: `/adm/flats?building_id=${buildingID}`,
                method: "GET"
            }).then(r => {
                let flats = []
                if (r.status == 200) {
                    r.response.data.forEach(flat => {
                        flats.push({
                            id: flat.id,
                            number: flat.flat,
                            entranceNumber: flat.entrance,
                            activationPassword: flat.register_code
                        })
                    })
                }
                ctx.commit("setFlats", {buildingID, list: flats})
            })
        },
        loadIntercoms(ctx, buildingID) {
            ctx.dispatch("request", {
                path: `/adm/panels?building_id=${buildingID}`,
                method: "GET"
            }).then(r => {
                let intercoms = []
                r.response.data.forEach(intercom => {
                    intercoms.push({
                        id: intercom.id,
                        entranceNumber: intercom.entrance,
                        name: intercom.description,
                        flatsRanges: intercom.connected_flats,
                        ip: intercom.ip,
                        port: intercom.port,

                        ipForVideo: intercom.video_host,
                        loginForVideo: intercom.video_username,
                        passwordForVideo: intercom.video_password,
                        portForVideo: intercom.video_port,

                        SIPAddress: intercom.aster_address,
                        SIPLogin: intercom.aster_username,
                        SIPPassword: intercom.aster_password,

                        loginForHTTP: intercom.username,
                        passwordForHTTP: intercom.password,

                        // data for front
                        active: false
                    })
                })
                ctx.commit("setIntercoms", {buildingID, list: intercoms})
            })
        }
    },
    mutations: {
        clearItems(state) {
            state.items = []
        },
        changeIntercomActive(state, {houseID, index}) {
            for (let i = 0; i < state.items.length; i++) {
                if (state.items[i].id == houseID) {
                    state.items[i].intercoms[index].active = !state.items[i].intercoms[index].active
                }
            }
        },
        addItem(state, item) {
            state.items.push(item)
        },
        setFlats(state, {buildingID, list}) {
            for (let i = 0; i < state.items.length; i++) {
                if (state.items[i].id == buildingID) {
                    state.items[i].flats = list
                }
            }
        },
        setIntercoms(state, {buildingID, list}) {
            for (let i = 0; i < state.items.length; i++) {
                if (state.items[i].id == buildingID) {
                    state.items[i].intercoms = list
                }
            }
        },
        setActiveHouse(state, id) {
            state.activeHouse = id
        }
    },
    getters: {
        streets(state) {
            let list = []

            state.items.forEach(item => {
                let found = false
                for (let i = 0; i < list.length; i++) {
                    if (list[i].name == item.street) {
                        found = true
                        list[i].houses.push({id: item.id, number: item.houseNumber})
                    }
                }

                if (!found) {
                    list.push({
                        name: item.street,
                        houses: [{id: item.id, number: item.houseNumber}]
                    })
                }

            })

            return list
        },
        activeHouse(state) {
            for (let i = 0; i < state.items.length; i++) {
                if (state.items[i].id == state.activeHouse) {
                    return state.items[i]
                }
            }
            return null
        },
        activeHouseID(state) {
            return state.activeHouse
        }
    }
}